export enum EStringToBoolean {
  True = 'true',
  False = 'false',
}
